<template>
    <nav class="footer-menu">
        <div v-for="(item, index) in filteredMenuItems" :key="index" class="menu-item"
            :class="{ active: isActiveRoute(item.route) }" @click="navigateTo(item.route)">
            <div class="menu-icon">
                <AppIcon :icon="item.icon" class="icon" />
                <span v-if="item.showBadge && cartCount > 0" class="badge">
                    {{ cartCount }}
                </span>
            </div>
            <span class="menu-label">{{ item.label }}</span>
        </div>
    </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { menuItems } from "@/constant/menu-footer";

export default {
    name: "MobileFooter",
    methods: {
        navigateTo(route) {
            this.$router.push(`/${route}`);
        },
        isActiveRoute(route) {
            // Periksa apakah rute saat ini sesuai
            return this.$route.path === `/${route}`;
        },
    },
    computed: {
        ...mapState("user", {
            isGuest: (state) => state.isGuest, // Ambil isGuest dari Vuex
        }),
        ...mapGetters("cart", ["cartCount"]),

        filteredMenuItems() {
            return menuItems.filter((item) => {
                if (item.guestOnly && !this.isGuest) return false; // Sembunyikan jika bukan guest
                if (item.authOnly && this.isGuest) return false; // Sembunyikan jika guest
                return true;
            });
        },

        uppercaseUserName() {
            const name = this.user?.Name || "Guest";
            const trimmedName = name.length > 12
                ? `${name.slice(0, 8)}...`
                : name; // Potong nama jika lebih dari 12 karakter dan tambahkan '...'
            return `${trimmedName.charAt(0).toUpperCase()}${trimmedName.slice(1).toLowerCase()}`;
        },
    }
};
</script>

<style scoped>
.footer-menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background: linear-gradient(to right, #ffffff, #f8f9fa);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 1000;
}

.menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #6b7280; /* Gray color */
    font-size: 12px;
    transition: color 0.3s ease;
    cursor: pointer;
}

.menu-item.active {
    color: #007bff;
    background: none; /* Blue for active menu */
}

.menu-item:hover {
    color: #0056b3; /* Darker blue on hover */
}

.menu-icon {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    /* background: #f1f5f9; */
    border-radius: 50%;
    transition: background 0.3s ease;
}

.menu-item:hover .menu-icon {
    background: #e2e8f0; /* Slightly darker on hover */
}

.icon {
    font-size: 24px;
    color: inherit;
}

.badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ef4444; /* Red badge */
    color: #ffffff;
    font-size: 10px;
    font-weight: bold;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.menu-label {
    margin-top: 4px;
}
</style>